import produce from 'immer';

import handleWallPostStream from '../../components/Club/Wall/utils/handleWallPostStream';
import type { WallPosts } from '../../components/Club/Wall/utils/normalizeWallPosts';
import type { PageData } from '../../types/common';

export const setWallPosts = (state: PageData, { response }: { response: WallPosts[] }) =>
  produce(state, (draft) => {
    draft.wallPosts = handleWallPostStream(draft.wallPosts, response);
  });

export const clearWallPosts = (state: PageData) =>
  produce(state, (draft) => {
    draft.wallPosts = [];
  });
